import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Row, Col, Button } from "react-bootstrap";

const ContactUs = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    dlaMember: "",
    enquiry: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Data Submitted:", formData);
    alert("Enquiry submitted! Check console.");
  };

  // Breadcrumb click handler
  const handleBreadcrumbClick = (path) => {
    navigate(path);
  };

  return (
    <div className="w-full mt-52 mx-auto">
      <div className="w-full px-4 sm:px-6 md:px-8 lg:px-10 xl:px-12 mx-auto">
        
        {/* BREADCRUMB - Fixed */}
        <div className="flex flex-wrap items-center text-gray-500 mb-4 md:mb-6 text-sm md:text-base mt-4">
          <span 
            className="cursor-pointer hover:underline hover:text-[#70B444] transition-colors"
            onClick={() => handleBreadcrumbClick("/")}
          >
            Home
          </span>
          <span className="mx-2">»</span>
          <span className="text-[#70B444] font-medium">
            Contact Us
          </span>
        </div>

        {/* HEADING */}
        <h1 className="text-3xl font-bold text-[#7db63c] border-b-2 border-[#7db63c] pb-3 mb-8">
          Contact Us
        </h1>

        {/* MAIN CONTENT */}
        <div className="flex flex-col md:flex-row">

          {/* LEFT */}
          <div className="flex-1 md:mr-8 lg:mr-16">

            <h2 className="text-2xl font-semibold text-[#7db63c] border-b-2 border-[#868686] pb-3 mb-8">
              DLA Office Hours
            </h2>

            <p className="text-gray-700">
              DLA Member Telephone Support is between 9.30 to 15.00 Monday to Friday
            </p>
            <p className="text-gray-700 mb-8">
              Email Support is from 9.30 to 16.00 Monday to Friday.
            </p>

            <p className="text-gray-700 mb-6">
              If you would like to contact us outside office hours, please fill in the enquiry box or email us.
            </p>

            <h2 className="text-2xl font-semibold text-[#7db63c] mb-4">
              Make an Enquiry
            </h2>

            {/* FORM */}
            <Form onSubmit={handleSubmit} className="space-y-5">

              <Form.Group>
                <Form.Label className="block font-semibold mb-1">
                  Name <span className="text-red-700">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  required
                  onChange={handleChange}
                  className="border border-gray-300 rounded-md px-4 py-2 focus:ring-2 focus:ring-green-400 outline-none w-full"
                />
              </Form.Group>

              <Form.Group>
                <Form.Label className="block font-semibold mb-1">
                  Email <span className="text-red-700">*</span>
                </Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  required
                  onChange={handleChange}
                  className="border border-gray-300 rounded-md px-4 py-2 focus:ring-2 focus:ring-green-500 outline-none w-full"
                />
              </Form.Group>

              <Form.Group>
                <Form.Label className="block font-semibold mb-1">
                  Phone <span className="text-red-700">*</span>
                </Form.Label>
                <Form.Control
                  type="tel"
                  name="phone"
                  required
                  onChange={handleChange}
                  className="border border-gray-300 rounded-md px-4 py-2 focus:ring-2 focus:ring-green-500 outline-none w-full"
                />
              </Form.Group>

              <Form.Group>
                <Form.Label className="block font-semibold mb-1">
                  Are you a DLA member? <span className="text-red-700">*</span>
                </Form.Label>
                <Form.Select
                  name="dlaMember"
                  required
                  onChange={handleChange}
                  className="border border-gray-300 rounded-md px-4 py-2 focus:ring-2 focus:ring-green-500 outline-none w-full"
                >
                  <option value="">Select</option>
                  <option value="yes">Yes</option>
                  <option value="no">No</option>
                </Form.Select>
              </Form.Group>

              <Form.Group>
                <Form.Label className="block font-semibold mb-1">
                  Your Enquiry <span className="text-red-700">*</span>
                </Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  name="enquiry"
                  required
                  onChange={handleChange}
                  className="border border-gray-300 rounded-md px-4 py-2 focus:ring-2 focus:ring-green-500 outline-none w-full"
                />
              </Form.Group>

              <Button
                type="submit"
                className="!bg-[#7db63c] text-white !mb-10 px-8 py-2 rounded-md text-lg border-0 hover:bg-green-700"
              >
                Submit
              </Button>

            </Form>
          </div>

          {/* RIGHT */}
          <div className="flex-1 md:ml-8 lg:ml-16 mt-8 md:mt-0">
            <h2 className="text-2xl font-semibold text-[#7db63c] border-b-2 border-[#868686] pb-3 mb-8">
              Our Details
            </h2>

            <div className="text-gray-700 mb-6">
              <p className="font-bold mb-5">Dental Laboratories Association</p>
              <p className="mb-4">
                House no, 183 St 4, <br />Block C, Punjab CHS, Cantt, <br />54000 Lahore, Pakistan
              </p>
              <p className="mb-4">Telephone: +92 328 9045585</p>
              <p>
                <a href="mailto:info@example.com" className="text-[#7db63c] hover:underline">
                  Email Us
                </a>
              </p>
            </div>

            <h2 className="text-2xl font-semibold text-[#7db63c] border-b-2 border-[#868686] pb-3 mb-8">
              Our Location
            </h2>

            <div className="w-full h-[280px] border rounded-md overflow-hidden">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d38040.52452816001!2d74.37340000000002!3d31.45710000000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x39188f573545fe53%3A0xdf6b30369c13af31!2sHIRA%20DENTAL%20LABORATORY%20(PRIVATE)%20LIMITED%2C%20House%20no%2C%20183%20St%204%2C%20Block%20C%20Punjab%20CHS%2C%20Cantt%2C%2054000%2C%20Pakistan!3m2!1d31.457112!2d74.3736204!5e1!3m2!1sen!2s!4v1770219127386!5m2!1sen!2s"
                className="w-full h-full border-0"
                loading="lazy"
                title="DLA Location"
              />
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default ContactUs;